export default {
    "type": "string",
    "enum": [
        "upload",
        "draft",
        "publish",
        "trash"
    ],
    "default": ""
}